

























































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class ChangePlanItem extends Vue {
  @Prop()
  plan: Billing.BillingPlan | {};

  @Prop({})
  selectedPlanId: string;

  @Prop()
  showSelectPlanButton: boolean;

  @Prop()
  handlePlanSelect;
}
